import React from 'react';
import { classes } from '../CUtil';

const OurLogo = (props) => {
	const cls = classes("ad_navbar_brand_logo", props.className);
	let alt, src;
	const dark = !!props.dark;

	if (IS_AKTIEDYSTEN_DK) {
		alt = "Aktiedysten";;
		src = dark ? "https://static.aktiedysten.dk/gfx/aktiedysten-logo-2023-dark-0.svg" : "https://static.aktiedysten.dk/gfx/aktiedysten-logo-2023-white-0.svg";
	} else if (IS_AKTIEKAMPEN_SE) {
		alt = "Aktiekampen";
		src = dark ? "https://static.aktiedysten.dk/gfx/aktiekampen-logo-2023-0-dark.svg" : "https://static.aktiedysten.dk/gfx/aktiekampen-logo-2023-white-0.svg";
	} else if (IS_INVESTSPIEL_DE) {
		alt = "Investspiel";
		src = dark ? "https://static.aktiedysten.dk/gfx/investspiel-logo-2023-0-dark.svg" : "https://static.aktiedysten.dk/gfx/investspiel-logo-2023-white-0.svg";
	} else if (IS_TRADERR_COM) {
		alt = "Traderr";
		src = dark ? "https://static.aktiedysten.dk/gfx/traderr-logo-2023-dark-0.svg" : "https://static.aktiedysten.dk/gfx/traderr-logo-2023-white-0.svg";
	}
	return <img alt={alt} className={cls} src={src}/>;
}

export default OurLogo;



// WEBPACK FOOTER //
// ./src/c/OurLogo.js